// 0 so no tag ever renders as a named chip: every tag collapses into the
// color-dot chip (`collapseOverflow`), showing only colors, never label text.
export const MAX_VISIBLE_TAGS = 0
export const MAX_OVERFLOW_DOTS = 3
